export default "__VITE_ASSET__536e74de__"